import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropTwitchClips(slug?: string) {
    return useQuery({
        queryKey: ["drop-twitch-clips", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentTwitchClips({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 10 * 60 * 1000,
    });
}
